<template lang="pug">
AppSelect(
  v-model="selected"
  :options="ACTIVITY_LEVEL_FILTERS"
  :select2-options="select2Options"
)
</template>

<script>
import { ACTIVITY_LEVEL_FILTERS } from '~/app_constants';

export default {
  name: 'ActivitiesActivityLevelFilter',
  props: {
    value: {
      type: String,
    },
  },
  emits: ['input'],
  data: () => ({
    ACTIVITY_LEVEL_FILTERS,
    select2Options: {
      allowClear: true,
      multiple: false,
      width: '100%',
      placeholder: 'All levels',
    },
  }),
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(activityLevel) {
        this.$emit('input', activityLevel);
      },
    },
  },
};
</script>
